import { createId } from '@paralleldrive/cuid2';
import { useState } from 'react';

import type { CreateAsnDTO } from '@invenco/supply-interface';

import { WizardStep } from '@/components/wizard';
import type { WizardStepDefinition } from '@/components/wizard/wizard-context';

import {
  EditableAsnLinesCard,
  type AsnLine,
  type AsnLineAddInput,
  type AsnLineUpdatePatch,
} from '../asn-lines-card';

type ItemsStepProps = {
  step: WizardStepDefinition;
  onChange: (input: Partial<CreateAsnDTO>) => void;
};

export function ItemsStep({ step, onChange }: ItemsStepProps) {
  const [lines, setLines] = useState<AsnLine[]>([]);

  const submitSection = () => {
    if (!lines.length) return false;

    onChange({
      asnLines: lines.map(
        ({ skuName, description, qtyExpected, unitPurchaseCost, unitCostTotal }) => ({
          skuName,
          description,
          qtyExpected,
          unitPurchaseCost,
          unitCostTotal,
        }),
      ),
    });
    return true;
  };

  const addLine = async (line: AsnLineAddInput) => {
    setLines((currentLines) => [...currentLines, { id: createId(), ...line }]);
  };

  const updateLine = async (lineId: string, patch: AsnLineUpdatePatch) => {
    setLines((currentLines) =>
      currentLines.map((line) => (line.id === lineId ? { ...line, ...patch } : line)),
    );
  };

  const deleteLine = async (lineId: string) => {
    setLines((currentLines) => currentLines.filter((line) => line.id !== lineId));
  };

  return (
    <WizardStep step={step} complete={lines.length > 0} onSubmitStep={submitSection}>
      <div>
        <EditableAsnLinesCard
          title="Add item(s)"
          emptyMessage={null}
          lines={lines}
          onAddLine={addLine}
          onUpdateLine={updateLine}
          onDeleteLine={deleteLine}
        />
      </div>
    </WizardStep>
  );
}
